import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  Output,
  WritableSignal
} from '@angular/core';
import { WidgetParams } from '@jeppesen-foreflight/jmkw-types';

@Component({
  selector: 'jmkw-widget-control-bar',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './widget-control-bar.component.html',
  styleUrl: './widget-control-bar.component.scss'
})
export class WidgetControlBarComponent {
  @Input() widgetParams?: WidgetParams;
  @Input() id?: string;

  @Output() expand = new EventEmitter<boolean>();
  @Output() closeWidget = new EventEmitter<void>();

  expanded = true;

  get title(): string {
    return this.widgetParams?.title ?? '';
  }

  get subtitle(): string {
    return this.widgetParams?.subtitle ?? '';
  }

  get info(): WritableSignal<string> | undefined {
    return this.widgetParams?.widgetTitleBarInfo;
  }

  toggleExpandedState(): void {
    this.expanded = !this.expanded;
    this.expand.emit(this.expanded);
  }

  /**
   * Emits the close widget event
   */
  onClose(): void {
    this.closeWidget.emit();
  }
}
